
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import TermsButton from '@/components/common/TermsButton';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Prices`}</h1>
    <p>{`Prices are subject to change depending on the complexity of your original character.`}</p>
    <p>{`All prices are in USD!`}</p>
    <p>{`If you have specific artwork needs please do not feel shy, contact me and I can give you a quote for any project!`}<br />{`
`}<a parentName="p" {...{
        "href": "/contact"
      }}>{`Click `}<strong parentName="a"><em parentName="strong">{`HERE`}</em></strong>{` to order your commission today! ^^`}</a></p>
    <TermsButton mdxType="TermsButton" />
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/c/raspberrystudios"
      }}><img parentName="a" {...{
          "src": "/images/speedpaint.png",
          "alt": "Speedpaints available for $5 USD"
        }}></img></a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;